import { render } from "./ReviewModal.vue?vue&type=template&id=249e59b7"
const script = {}

import exportComponent from "D:\\CY_selflearning\\self-learning\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__